import React from 'react';
import styles from './style.module.scss';

var ImageCard = function ImageCard(_ref) {
  var headline = _ref.headline,
      actions = _ref.actions,
      children = _ref.children,
      fullHeight = _ref.fullHeight;
  return React.createElement("div", {
    className: classNames(fullHeight, actions)
  }, headline && React.createElement("div", {
    className: styles.cardHeader
  }, headline), React.createElement("div", {
    className: styles.cardContent
  }, children, actions && React.createElement("div", {
    className: styles.cardActions
  }, actions)));
};

var classNames = function classNames(fullHeight, actions) {
  return styles.card + (fullHeight ? " ".concat(styles.fullHeight) : '') + (actions ? " ".concat(styles.hasActions) : '');
};

export default ImageCard;